<form [formGroup]="addEditScenarioForm" autocomplete="off">
  <div class="form-controls-padding">
    <mat-form-field appearance="outline" hideRequiredMarker="true">
      <mat-label i18n="@@scenarioNameLabel">Scenario name</mat-label>
      <input
        matInput
        type="text"
        formControlName="scenarioName"
        placeholder="What are you working on?"
        i18n-placeholder="@@scenarioNamePlaceholder"
      />
      @if (emptyScenarioName()) {
        <mat-error i18n="@@emptyScenarioNameError">
          Please enter a scenario name
        </mat-error>
      }
      @if (!uniqueScenarioName()) {
        <mat-error i18n="@@uniqueScenarioNameError">
          Another scenario has this name, please choose another
        </mat-error>
      }
    </mat-form-field>
    @if (hasSharedNameConflict()) {
      <div>
        <mat-error i18n="@@uniqueScenarioNameError" class="error-message">
          Another scenario has this name, please choose another
        </mat-error>
      </div>
    }
    @if (enableScenarioSharing) {
      <mat-form-field appearance="outline" hideRequiredMarker="true">
        <mat-label i18n="@@permissionLevelLabel">Permission level</mat-label>
        <mat-select
          formControlName="permissionLevel"
          placeholder="Choose a permission level"
          i18n-placeholder="@@permissionLevelPlaceholder"
        >
          <mat-option value="private" i18n="@@permissionPrivate"
            >Private</mat-option
          >
          <mat-option value="shared" i18n="@@permissionShared"
            >Shared</mat-option
          >
        </mat-select>
      </mat-form-field>
    }
    @if (isBatchScenario && mode === dialogMode.Add) {
      <div class="radio-buttons-container">
        <mat-radio-group
          aria-label="Select scenario type"
          i18n-aria-label="@@selectScenarioTypeAriaLabel"
          formControlName="scenarioBatchTypeSelection"
        >
          <mat-radio-button
            [value]="'standard'"
            class="radio-button-margin-right"
          >
            <mat-label i18n="@@standardScenarioOption"
              >Standard Scenario</mat-label
            >
          </mat-radio-button>
          <mat-radio-button [value]="'batch'">
            <mat-label i18n="@@batchScenarioOption">Batch Scenario</mat-label>
          </mat-radio-button>
        </mat-radio-group>
        @if (
          addEditScenarioForm.controls.scenarioBatchTypeSelection.value ===
          'batch'
        ) {
          <div>
            <div class="warning-text" i18n="@@batchScenarioWarning">
              Note: Scenarios with batch reporting enabled will be locked after
              running and cannot be modified.
            </div>
          </div>
        }
      </div>
    }

    <h4
      i18n="@@buildFromExistingScenarioLabel"
      style="color: gray; margin-top: 16px"
    >
      Build from existing scenario (optional)
    </h4>
    <atlas-scenario-name-chip-list
      placeholder="Type to select or search"
      formControlName="deltaScenarios"
      chipListTitle="Copy locations from"
      [allItems]="deltaScenarios"
      [itemTooltips]="itemTooltips"
      [sharedScenarios]="sharedScenarioNames"
      [hint]="deltaHint"
      (valueChanged)="onDeltaScenariosChanged($event)"
      [allowFreeTyping]="true"
      i18n-placeholder="@@deltaScenariosPlaceholder"
      i18n-chipListTitle="@@deltaScenariosTitle"
    ></atlas-scenario-name-chip-list>
    <div style="margin-bottom: 15px"></div>
    <atlas-scenario-name-chip-list
      placeholder="Type to select or search"
      formControlName="baseScenarios"
      chipListTitle="Base"
      [allItems]="baseScenarios"
      [itemTooltips]="itemTooltips"
      [sharedScenarios]="sharedScenarioNames"
      [fixedItems]="baseFixedScenarios"
      [hint]="baseHint"
      (valueChanged)="onBaseScenariosChanged($event)"
      [allowFreeTyping]="true"
      i18n-placeholder="@@baseScenariosPlaceholder"
      i18n-chipListTitle="@@baseScenariosTitle"
    ></atlas-scenario-name-chip-list>
  </div>
</form>
